module.exports = __webpack_public_path__ + "media/images/themes/deep_space/header-0812956c99cef1dda726e94485904bd2.png";